import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from 'modules/ui';
import styles from './CheckboxUI.module.scss';

function CheckboxUI({ selected, disabled, label, onClick, id }) {
  const containerClasses = classNames(styles.container, {
    [styles.disabled]: disabled,
  });

  const iconClasses = classNames(styles.icon, {
    [styles['icon--selected']]: selected,
  });

  const inputId = id || (label ? `checkbox-${label}` : undefined);

  function handleKeyDown(event) {
    if (disabled) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (onClick) {
        onClick();
      }
    }
  }

  return (
    <label className={containerClasses}>
      <input
        type="checkbox"
        checked={selected}
        disabled={disabled}
        onChange={onClick}
        id={inputId}
        className={styles.label}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
      />
      <div className={iconClasses}>
        {selected && <Icon name="checked" color="#fff" size={24} />}
      </div>
      <span>{label}</span>
    </label>
  );
}

CheckboxUI.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
};

export default memo(CheckboxUI);
